/**
 * AN EDIT SENDS WHAT CHANGED, NOTHING ELSE.
 *
 * An edit form holds every field of the record — including ones the server owns (a dealer's code
 * and status, a farmer's "registered via") and ones only some people may write. PATCHing all of them
 * back got every save refused, because the server rejects a patch that touches a field the person may
 * not write, even when its value is unchanged (R-000871, 15 Sep 2026; farmers, 25 Sep 2026).
 *
 * Only the fields the form submitted are compared; one that was cleared is sent as null so the
 * clearing saves. Values compare as trimmed strings, so `22.5125570` vs `22.512557` from a number
 * input are shaped alike by the caller first (pass both through the same payload builder).
 */
export const changedFields = (before: Record<string, any>, after: Record<string, any>, fields: string[]) => {
  const norm = (v: unknown) => (v === null || v === undefined ? '' : String(v).trim());
  return Object.fromEntries(fields
    .filter((k) => norm(after[k]) !== norm(before[k]))
    .map((k) => [k, after[k] === undefined ? null : after[k]]));
};
